import React, { useState, useEffect, useContext } from 'react';
import StoreContext from '../../context/StoreContext';
import './MiniCartButton.scss';

const countQuantity = (lineItems) => {
  let quantity = 0;
  lineItems.forEach((item) => {
    quantity += item.quantity;
  });
  return quantity;
};

const MiniCartButton = (props) => {
  const {
    toggleMinicartHandler,
  } = props;
  const context = useContext(StoreContext);
  const { checkout } = context;
  const [quantity, setQuantity] = useState(countQuantity(checkout ? checkout.lineItems : []));

  useEffect(() => {
    setQuantity(countQuantity(checkout ? checkout.lineItems : []));
  }, [checkout]);

  return (
    <div className="mini-cart-button">
      <button
        type="button"
        onClick={event => toggleMinicartHandler(event)}
        className="mini-cart clickable"
        aria-label="Open to the Cart"
      >
        <div className="icon">
          <svg viewBox="0 0 42 45" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
              <path
                d="M18.274.5c.829.039 1.545.209 2.163.475a5.83 5.83 0 011.668-.437.824.824 0 01.253-.038h1.649c4.586.215 5.732 4.443 5.732 6.664v4.515h7.525L41.349 44.5H0l3.081-32.82 8.026-.001V7.164c0-2.142 1.134-6.152 5.265-6.626A.822.822 0 0116.625.5h1.649zm4.299 12.612H12.54v3.583c0 .359-.358.717-.716.717-.43 0-.717-.287-.717-.717v-3.583H4.371L1.577 43.067l26.792-.001 1.398-14.894 1.406-15.06h-7.167v3.583c0 .359-.358.717-.716.717-.43 0-.717-.287-.717-.717v-3.583zm13.4 0h-3.359l-1.413 15.052-1.39 14.903h9.961l-3.798-29.955zM20.389 2.59l-.155.104C18.245 4.108 18.202 7 18.202 7.164L18.2 11.68h4.372V7.145c-.004-.31-.1-3.22-2.185-4.556zm3.547-.656h-1.362a5.34 5.34 0 00-.595.063c1.556 1.487 2.029 3.742 2.029 5.168l-.001 4.515h4.3V7.145c-.005-.394-.161-5.001-4.371-5.212zm-5.733 0H16.84c-3.728.187-4.277 3.822-4.357 4.925.038.089.058.193.058.306l-.001 4.515h4.3V7.164c0-1.421.5-3.665 2.042-5.152a4.995 4.995 0 00-.68-.079z"
                fill="#000"
                fillRule="nonzero"
              />
            </g>
          </svg>
          {quantity !== 0 && (
            <div className="cart-counter">
              <span className="qty-count">{quantity}</span>
            </div>
          )}
        </div>
      </button>
    </div>
  );
};

export default MiniCartButton;
